const ProtectedMenu = ({ permittedPages, pageContext, children }) => {
  const context = pageContext;
  var results = false;
  
  if (context != undefined) {
    context.Permissions?.map((permission :any) => {
      if (
        permission.SystemName === permittedPages &&
        permission.Role === context.loggedInAs.label
      ) {
        results = true;
      }
    });
  }
  if (!results) {
    return null;
  }
  return children;
};
export default ProtectedMenu;
